var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpher2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1711,
    height: 3018,
    viewBox: "0 0 1711 3018",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_5200_24090)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_5200_24090_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.71293 0.71293 -0.71293 0.71293 1320.86 1508.86)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1000.99,
    y: -1000.99,
    width: 2001.98,
    height: 2001.98
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(217, 217, 217, 1) 0deg,rgba(41, 126, 255, 1) 0.036deg,rgba(191, 56, 255, 1) 78.75deg,rgba(206, 104, 255, 1) 187.5deg,rgba(40, 203, 255, 1) 268.125deg,rgba(225, 161, 255, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 0.1
    }
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1320.86,
    cy: 1508.86,
    r: 1008.24,
    transform: "rotate(-45 1320.86 1508.86)",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.85098040103912354,\"g\":0.85098040103912354,\"b\":0.85098040103912354,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.16250002384185791,\"g\":0.49749988317489624,\"b\":1.0,\"a\":1.0},\"position\":9.9999997473787516e-05},{\"color\":{\"r\":0.75066614151000977,\"g\":0.22083336114883423,\"b\":1.0,\"a\":1.0},\"position\":0.218750},{\"color\":{\"r\":0.81066632270812988,\"g\":0.40833336114883423,\"b\":1.0,\"a\":1.0},\"position\":0.52083331346511841},{\"color\":{\"r\":0.15833336114883423,\"g\":0.79799979925155640,\"b\":1.0,\"a\":1.0},\"position\":0.74479168653488159},{\"color\":{\"r\":0.88266658782958984,\"g\":0.63333332538604736,\"b\":1.0,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[],\"transform\":{\"m00\":1425.8602294921875,\"m01\":-1425.8602294921875,\"m02\":1320.8602294921875,\"m10\":1425.8602294921875,\"m11\":1425.8602294921875,\"m12\":83.000091552734375},\"opacity\":0.10000000149011612,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5200_24090",
    x: -187.375,
    y: 0.624878,
    width: 3016.47,
    height: 3016.47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_5200_24090"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_5200_24090_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1320.86,
    cy: 1508.86,
    r: 1008.24,
    transform: "rotate(-45 1320.86 1508.86)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpher2);
export default __webpack_public_path__ + "static/media/spher2.65caa6a9db815153751f55438b9c4190.svg";
export { ForwardRef as ReactComponent };